import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Stack,
  Pagination,
} from "@mui/material";
import Breadcrumb from "../../DefaultComponent/BreadCrumb";
import Spinner from "../../DefaultComponent/Spinner";
import ToastDefault from "../../DefaultComponent/Toast";
import { formatDate, calculateTotalPages } from "../../../utils/Helper";
import { DLQMessageListAction } from "../../../Redux/Actions/PaymentAction";

export interface DLQMessage {
  content_type_id: number;
  external_service_resource_id: number | null;
  feature_id: number;
  feature_name: string;
  action_event: string;
  object_id: number;
  resource_name: string;
  resource_id: number;
  event_type: string;
  reason: string;
  entity_id: number;
  entity_type: string;
  org_member_id: number;
  event_time: string;
}

interface DLQResponse {
  row: DLQMessage[];
  total_count: number;
  count: number;
  next: number | null;
  previous: number | null;
}

const DLQMessages: React.FC = () => {
  const dispatch = useDispatch<any>();
  const dlqData = useSelector((state: any) => state.DLQMessagesListData);

  const [messages, setMessages] = useState<DLQMessage[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [rowsPerPage] = useState<number>(10);

  const fetchMessages = (pageNum: number = page) => {
    setLoading(true);
    const params = `?page=${pageNum}&page_size=${rowsPerPage}`;
    dispatch(DLQMessageListAction(params)).finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchMessages();
  }, [dispatch, page]);

  useEffect(() => {
    if (dlqData?.data?.row) {
      setMessages(dlqData.data.row);
    }
  }, [dlqData]);

  return (
    <>
      {loading && <Spinner />}
      <div className="page-wrapper card" style={{ display: "flex", flexDirection: "column" }}>
        <div className="col-md-12">
          <Breadcrumb
            pageTitle="DLQ Messages"
            breadcrumbs={[{ label: "DLQ Messages", path: "/dlq-messages", isActive: true }]}
          />
        </div>

        <Box sx={{ m: 2 }}>
          <Box sx={{ m: 2, overflowX: 'auto' }}>
          <TableContainer component={Paper} sx={{ minWidth: 1200 }}>
            <Table aria-label="DLQ Messages Table">
              <TableHead sx={{ backgroundColor: "#0555c8" }}>
                <TableRow>
                  <TableCell sx={{ color: "white" }}>Serial Number</TableCell>
                  <TableCell sx={{ color: "white" }}>Content Type ID</TableCell>
                  <TableCell sx={{ color: "white" }}>External Resource ID</TableCell>
                  <TableCell sx={{ color: "white" }}>Feature ID</TableCell>
                  <TableCell sx={{ color: "white" }}>Feature Name</TableCell>
                  <TableCell sx={{ color: "white" }}>Action Event</TableCell>
                  <TableCell sx={{ color: "white" }}>Object ID</TableCell>
                  <TableCell sx={{ color: "white" }}>Resource Name</TableCell>
                  <TableCell sx={{ color: "white" }}>Resource ID</TableCell>
                  <TableCell sx={{ color: "white" }}>Event Type</TableCell>
                  <TableCell sx={{ color: "white" }}>Reason</TableCell>
                  <TableCell sx={{ color: "white" }}>Entity ID</TableCell>
                  <TableCell sx={{ color: "white" }}>Entity Type</TableCell>
                  <TableCell sx={{ color: "white" }}>Org Member ID</TableCell>
                  <TableCell sx={{ color: "white" }}>Event Time</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {messages.length > 0 ? (
                  messages.map((msg, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{(page - 1) * rowsPerPage + idx + 1}</TableCell>
                      <TableCell>{msg.content_type_id}</TableCell>
                      <TableCell>{msg.external_service_resource_id ?? "N/A"}</TableCell>
                      <TableCell>{msg.feature_id}</TableCell>
                      <TableCell>{msg.feature_name}</TableCell>
                      <TableCell>{msg.action_event}</TableCell>
                      <TableCell>{msg.object_id}</TableCell>
                      <TableCell>{msg.resource_name}</TableCell>
                      <TableCell>{msg.resource_id}</TableCell>
                      <TableCell>{msg.event_type}</TableCell>
                      <TableCell>{msg.reason}</TableCell>
                      <TableCell>{msg.entity_id}</TableCell>
                      <TableCell>{msg.entity_type}</TableCell>
                      <TableCell>{msg.org_member_id}</TableCell>
                      <TableCell>{formatDate(msg.event_time)}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={15} align="center">
                      No DLQ Messages Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        </Box>
              
        <div className="pagination-style">
          <Stack spacing={2}>
            <Pagination
              count={calculateTotalPages(dlqData?.data?.total_count || 0, rowsPerPage)}
              page={page}
              onChange={(e: any, newPage) => setPage(newPage)}
              color="primary"
              variant="outlined"
              shape="rounded"
            />
          </Stack>
        </div>
      </div>
      <ToastDefault />
    </>
  );
};

export default DLQMessages;
